import type { IconData } from '@stacksjs/iconify-core'

export const tuneAdjustVolumeSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 3.5a2 2 0 1 0 4 0v-1a2 2 0 1 0-4 0zm18.617 6.711a2 2 0 1 0-2.828-2.828l-.707.707a2 2 0 0 0 2.828 2.829zM24 7C14.611 7 7 14.611 7 24c0 4.154 1.49 7.96 3.965 10.914l8.974-8.975a1.5 1.5 0 0 1 2.122 2.122l-8.975 8.974A16.93 16.93 0 0 0 24 41c9.389 0 17-7.611 17-17S33.389 7 24 7m21.5 19a2 2 0 1 0 0-4h-1a2 2 0 1 0 0 4zm-40-2a2 2 0 0 1-2 2h-1a2 2 0 1 1 0-4h1a2 2 0 0 1 2 2m5.418 13.082a2 2 0 0 1 0 2.829l-.707.707a2 2 0 1 1-2.828-2.829l.707-.707a2 2 0 0 1 2.828 0m-3.535-26.87a2 2 0 0 1 2.828-2.829l.707.707a2 2 0 0 1-2.828 2.828zm29.699 26.87a2 2 0 0 0 0 2.829l.707.707a2 2 0 1 0 2.828-2.829l-.707-.707a2 2 0 0 0-2.828 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tuneAdjustVolumeSolid
